import * as React from "react";

function AddressBookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8 20.5h9.5a1 1 0 001-1V6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 4.075A1.07 1.07 0 016.066 3h9.444a1.07 1.07 0 011.066 1.075v13.41a1.07 1.07 0 01-1.066 1.075H6.066A1.07 1.07 0 015 17.485V4.075zm3.222 10.213a.79.79 0 010-1.256 4.185 4.185 0 012.566-.875c.965 0 1.855.326 2.566.875a.79.79 0 010 1.256 4.185 4.185 0 01-2.566.876 4.185 4.185 0 01-2.566-.876zm2.564-2.884c1.096 0 1.985-1.12 1.985-2.504 0-1.382-.889-2.503-1.985-2.503C9.689 6.397 8.8 7.517 8.8 8.9s.888 2.504 1.985 2.504z",
    clipRule: "evenodd"
  }));
}

export default AddressBookIcon;